export const GET_STATS = 'GET_STATS'
export const GET_STATS_SUCCESS = 'GET_STATS_SUCCESS'
export const GET_STATS_FAILED = 'GET_STATS_FAILED'

export const GET_APPOINTMENTS = 'GET_APPOINTMENTS'
export const GET_APPOINTMENTS_SUCCESS = 'GET_APPOINTMENTS_SUCCESS'
export const GET_APPOINTMENTS_FAILED = 'GET_APPOINTMENTS_FAILED'

export const GET_SUBSET = 'GET_APPOINTMENTS'
export const GET_SUBSET_SUCCESS = 'GET_APPOINTMENTS_SUCCESS'
export const GET_SUBSET_FAILED = 'GET_APPOINTMENTS_FAILED'

export const GET_MAP_STATS = 'GET_MAP_STATS'
export const GET_MAP_STATS_SUCCESS = 'GET_MAP_STATS_SUCCESS'
export const GET_MAP_STATS_FAILED = 'GET_MAP_STATS_FAILED'

export const GET_COMPANIES = 'GET_COMPANY'
export const GET_COMPANIES_SUCCESS = 'GET_COMPANY_SUCCESS'
export const GET_COMPANIES_FAILED = 'GET_COMPANY_FAILED'

export const GET_SHOPS = 'GET_COMPANY'
export const GET_SHOPS_SUCCESS = 'GET_COMPANY_SUCCESS'
export const GET_SHOPS_FAILED = 'GET_COMPANY_FAILED'

export const GET_WHOLESALER_ORDER_INFO_CSV = 'GET_WHOLESALER_ORDER_INFO_CSV'
export const GET_WHOLESALER_ORDER_INFO_CSV_SUCCESS = 'GET_WHOLESALER_ORDER_INFO_CSV_SUCCESS'
export const GET_WHOLESALER_ORDER_INFO_CSV_FAILED = 'GET_WHOLESALER_ORDER_INFO_CSV_FAILED'

export const GET_GMS_STATISTICS_CSV = 'GET_GMS_STATISTICS_CSV'
export const GET_GMS_STATISTICS_CSV_SUCCESS = 'GET_GMS_STATISTICS_CSV_SUCCESS'
export const GET_GMS_STATISTICS_CSV_FAILED = 'GET_GMS_STATISTICS_CSV_FAILED'

export const GET_SHOP_COUNTRIES = 'GET_SHOP_COUNTRIES'
export const GET_SHOP_COUNTRIES_SUCCESS = 'GET_SHOP_COUNTRIES_SUCCESS'
export const GET_SHOP_COUNTRIES_FAILED = 'GET_SHOP_COUNTRIES_FAILED'

export const SET_SHOP_ID = 'SET_SHOP_ID'
export const SET_COMPANY_UUID = 'SET_COMPANY_UUID'
export const SET_START_DATE = 'SET_START_DATE'
export const SET_END_DATE = 'SET_END_DATE'
export const SET_FILTERED_BY_MODULE = 'SET_FILTERED_BY_MODULE'
export const SET_STATS_COUNTRY = 'SET_STATS_COUNTRY'
